import React from "react";
import brandPattern from "./home-texture2.png";

function BrandPattern(props) {
  return <img src={brandPattern} alt="Rivile-mscan" {...props} />;
}

export default BrandPattern;
